import { Currency } from 'graphql/config';
import { useTranslation } from 'next-i18next';

import { GivingConfigQuery, useGivingConfigQuery } from '@/graphql/config';

export function useConfigQuery(language?: string) {
  const { i18n } = useTranslation();
  return useGivingConfigQuery({ lng: language ?? i18n.language }, { select });
}

const select = (data: GivingConfigQuery) => ({
  config: data.config,
  currencies: data.currencies?.data as Array<Currency>,
  frequencies: data.frequencies?.data,
  funds: data.funds?.data,
});
